import { useEffect, useState } from 'react';
import { useNotify, useTranslate } from 'react-admin';
import { LoadingPage } from '../../components/LoadingPage';
import { useAppContext } from '../../contexts/AppContext';
import { useUser } from '../../providers/userProvider';
import { apiUrl, httpClient } from '../../utils/httpUtils';
import { hasRole } from '../../utils/roles';
import { QualityList } from '../quality';
import { GraphicCard } from './GraphicCard';
import { MetricsCards } from './MetricsCards';
import { TopNotes } from './TopNotes';
import { TopTeamProgress } from './TopTeamProgress';
import Welcome from './Welcome';

const styles = {
  flex: { display: 'flex' },
  flexColumn: { display: 'flex', flexDirection: 'column' },
  leftCol: { flex: 1, marginRight: '0.5em' },
  rightCol: { flex: 1, marginLeft: '0.5em' },
  singleCol: { marginTop: '1em', marginBottom: '1em' },
};

const Dashboard = () => {
  const [metrics, setMetrics] = useState([]);
  const [loading, setLoading] = useState(true);
  const notify = useNotify();
  const t = useTranslate();
  const { team, userId, loading: userLoading } = useUser();
  const { currentApp } = useAppContext();

  useEffect(() => {
    let isMounted = true;

    const getMetrics = async () => {
      try {
        const res = await httpClient(
          `${apiUrl}/metrics/progress${userId && !hasRole(['admin', 'gerente', 'editor']) ? '/me' : ''}`
        );
        if (res.status && res.status === 200) {
          if (isMounted) {
            setMetrics(res.json || []);
          }
        } else if (res.status && res.status === 422) {
          notify(t(res.message), { type: 'error' });
          if (isMounted) {
            setMetrics([]);
          }
        } else {
          if (isMounted) {
            setMetrics([]);
          }
        }
      } catch (error) {
        console.error('Failed to fetch metrics:', error);
        if (isMounted) {
          setMetrics([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    // Solo cargar métricas si estamos en la aplicación 'card'
    if (!userLoading && currentApp === 'card') {
      getMetrics();
    } else if (currentApp === 'quality') {
      // Para quality, no necesitamos métricas, solo marcar como no loading
      if (isMounted) {
        setLoading(false);
      }
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLoading, currentApp]);

  if (loading || userLoading) {
    return <LoadingPage />;
  }

  // Si la aplicación es Quality, mostrar QualityList
  if (currentApp === 'quality') {
    return <QualityList />;
  }

  // Si la aplicación es Card (por defecto), mostrar el dashboard normal
  return (
    <div>
      <div style={styles.flexColumn}>
        <Welcome metrics={metrics} loading={loading} />
        <MetricsCards
          metrics={metrics}
          loading={loading}
          title={true}
          progressBar={true}
        />
        <GraphicCard />
        {!hasRole(['admin', 'gerente', 'editor']) ? null : (
          <TopTeamProgress
            teamId={hasRole(['admin', 'gerente']) ? null : team}
          />
        )}
        <TopNotes
          title={t('resources.reports.list.title_top_notes')}
          teamId={hasRole(['admin', 'gerente']) ? null : team}
          userId={!hasRole(['admin', 'gerente', 'editor']) ? userId : null}
          filterTeams={true}
        />
        {!hasRole(['admin', 'gerente', 'editor']) ? (
          <TopTeamProgress teamId={team} />
        ) : null}
      </div>
    </div>
  );
};

export default Dashboard;
